import { isDevelop } from 'lib/env'
import * as division from 'constants/divisions'
import * as status from 'constants/statuses'

export const moduleList = [
  { id: 'Авто', name: 'Авто', division: division.ASTERX_DIVISION },
  {
    id: 'Авто продажа',
    name: 'Авто продажа',
    division: division.ASTERX_DIVISION
  },
  { id: 'Авто выкуп', name: 'Авто выкуп', division: division.ASTERX_DIVISION },
  { id: 'Carfin', name: 'Carfin', division: division.ASTERX_DIVISION },
  {
    id: 'Авто ключница',
    name: 'Авто ключница',
    division: division.ASTERX_DIVISION
  },
  { id: 'ППП', name: 'ППП', division: division.ASTERX_DIVISION },
  { id: 'BipiumX', name: 'BipiumX', division: division.ASTERX_DIVISION },
  { id: 'ППО', name: 'ППО', division: division.ASTERX_DIVISION },
  { id: 'Суперсет', name: 'Суперсет', division: division.ASTERX_DIVISION },
  { id: 'Новые авто', name: 'Новые авто', division: division.ASTERX_DIVISION },
  { id: 'Гарантии', name: 'Гарантии', division: division.ASTERX_DIVISION },
  { id: 'Комиссия', name: 'Комиссия', division: division.ASTERX_DIVISION },
  {
    id: 'Устройства',
    name: 'Устройства',
    division: division.HELP_DESK_DIVISION
  },
  {
    id: 'Сеть и интернет',
    name: 'Сеть и интернет',
    division: division.HELP_DESK_DIVISION
  },
  {
    id: 'Запрос на технику',
    name: 'Запрос на технику',
    division: division.HELP_DESK_DIVISION
  },
  {
    id: 'Сотовая связь',
    name: 'Сотовая связь',
    division: division.HELP_DESK_DIVISION
  },
  {
    id: 'Программное обеспечение',
    name: 'Программное обеспечение',
    division: division.HELP_DESK_DIVISION
  },
  { id: '1C', name: '1C', division: division.HELP_DESK_DIVISION },
  { id: 'Прочее', name: 'Прочее', division: division.HELP_DESK_DIVISION },
  {
    id: 'Видеонаблюдение',
    name: 'Видеонаблюдение',
    division: division.HELP_DESK_DIVISION
  },
  { id: 'СКУД', name: 'СКУД', division: division.HELP_DESK_DIVISION }
]

export const systemList = [
  { id: 'Доступы', name: 'Доступы', division: division.HELP_DESK_DIVISION },
  {
    id: 'Программное обеспечение и устройства',
    name: 'Программное обеспечение и устройства',
    division: division.HELP_DESK_DIVISION
  },
  {
    id: 'Запрос на технику',
    name: 'Запрос на технику',
    division: division.HELP_DESK_DIVISION
  },
  {
    id: 'Сеть, интернет и телефония',
    name: 'Сеть, интернет и телефония',
    division: division.HELP_DESK_DIVISION
  },
  {
    id: 'BS',
    name: 'BS',
    division: division.HELP_DESK_DIVISION
  },
  {
    id: '1C',
    name: '1C',
    division: division.HELP_DESK_DIVISION
  },
  {
    id: 'Видеонаблюдение',
    name: 'Видеонаблюдение',
    division: division.HELP_DESK_DIVISION
  },
  {
    id: 'Прочее',
    name: 'Прочее',
    division: division.HELP_DESK_DIVISION
  },
  {
    id:'Кредитный конвейер',
    name: 'Кредитный конвейер',
    division: division.HELP_DESK_DIVISION
  }
]

export const typeList = [
  { id: 'Ошибка', name: 'Ошибка' },
  { id: 'Операция', name: 'Операция' }
]
export const seoList = [{ id: 'СЭО', name: 'СЭО' }]

export const typeSeoList = [
  { id: 'Ошибка', name: 'Ошибка' },
  { id: 'Киоск', name: 'Киоск' },
  { id: 'Экран/звук', name: 'Экран/звук' }
]

export const serviceList = [
  { id: 'Изменить VIN МП', module: 'Авто выкуп', name: 'Изменить VIN МП' },
  { id: 'Вернуть на ОСС', module: 'Авто выкуп', name: 'Вернуть на ОСС' },
  { id: 'Вернуть с отказа', module: 'Авто выкуп', name: 'Вернуть с отказа' },
  {
    id: 'Смена звена сделки',
    module: 'Авто выкуп',
    name: 'Смена звена сделки'
  },
  {
    id: 'Вернуть сделку на этап',
    module: 'Авто выкуп',
    name: 'Вернуть сделку на этап'
  },
  { id: 'Изменить ЗН', module: 'Авто', name: 'Изменить ЗН' },
  { id: 'Управление стоком', module: 'Авто', name: 'Управление стоком' },
  {
    id: 'Изменить статус РЛ',
    module: 'Авто продажа',
    name: 'Изменить статус РЛ'
  },
  { id: 'Закрыть талон', module: 'СЭО', name: 'Закрыть талон' },
  { id: 'Другое', module: null, name: 'Другое' }
]

export const statusList = [
  { id: 7, label: 'Все', request: [] },
  { id: 1, label: status.NEW_STATUS, request: [status.NEW_STATUS] },
  {
    id: 2,
    label: status.IN_PROGRESS_STATUS,
    request: [status.IN_PROGRESS_STATUS]
  },
  {
    id: 3,
    label: status.NEED_REVISION_STATUS,
    request: [status.NEED_REVISION_STATUS]
  },
  { id: 4, label: status.POSTPONED_STATUS, request: [status.POSTPONED_STATUS] },
  { id: 5, label: status.EXECUTED_STATUS, request: [status.EXECUTED_STATUS] },
  { id: 6, label: status.DECLINED_STATUS, request: [status.DECLINED_STATUS] }
].filter(Boolean)
